import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            用户 <span className="text-primary-600">真实评价</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            来自数百万用户的真实反馈，是我们不断进步的动力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/50"
            >
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-fill text-background-300'
                    }`}
                  />
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/50">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-700 font-semibold text-sm">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}